<template>
  <div v-if="isLoading">
    <Loader />
  </div>
  <div v-else>
    <Navbar></Navbar>
    <div class="content-wrapper">
      <div class="main-content">
        <Vision />
        <video-section />
        <Features />
        <Numbers />
        <!-- <Experts />
        <Feedbacks /> -->
        <JoinUs />
      </div>
      <FooterItem />
    </div>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader.vue";
import Navbar from "@/components/Layout/Navbar.vue";
import Vision from "@/components/About/Vision.vue";
import VideoSection from "@/components/About/VideoSection.vue";
import Features from "@/components/About/Features.vue";
import Numbers from "@/components/About/Numbers.vue";
// import Experts from "@/components/Homepage/Experts.vue";
// import Feedbacks from "@/components/Homepage/Feedbacks.vue";
import JoinUs from "@/components/About/JoinUs.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Loader,
    Navbar,
    Vision,
    VideoSection,
    Features,
    Numbers,
    JoinUs,
    // Experts,
    // Feedbacks,
    FooterItem,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
    isLoading() {
      return this.$store.getters.isLoadingGlobal;
    },
  },
  methods: {
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "عن Planning Force - منصة التعليم الإلكتروني | من نحن؟"
          : "About Planning Force - e-Learning Platform | Who Are We?";

      const description =
        this.currentLanguage === "ar"
          ? "تعرف على Planning Force، منصة التعليم الإلكتروني التي تهدف إلى تمكين الأفراد من تطوير مهاراتهم وتحقيق النجاح من خلال دورات تعليمية عالية الجودة."
          : "Learn about Planning Force, the e-Learning platform dedicated to empowering individuals to enhance their skills and achieve success through high-quality courses.";

      const keywords =
        this.currentLanguage === "ar"
          ? "عن Planning Force, منصة التعليم الإلكتروني, دورات تعليمية, تطوير المهارات, من نحن"
          : "about Planning Force, e-learning platform, online courses, skill development, who we are";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/about-og-image.jpg",
          }, // Replace with your about page image URL
          { property: "og:url", content: "https://example.com/about" }, // Replace with your about page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/about-twitter-image.jpg",
          }, // Replace with your about page image URL
        ],
      });
    },
  },
  mounted() {
    this.updateHeadMeta();
   // this.$store.dispatch('GlobalData');
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
